"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLetter = void 0;
var getLetter = function (num) {
    var letter;
    if (num >= 26) {
        letter = (0, exports.getLetter)(((num / 26) >> 0) - 1);
    }
    else {
        letter = "";
    }
    return letter + String.fromCharCode((num % 26 >> 0) + 65);
};
exports.getLetter = getLetter;
